import { getAnalytics, logEvent, setUserId, setUserProperties } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getPerformance, trace } from 'firebase/performance';
import config from '../config.web';

const firebaseConfig = {
  apiKey: config.FB_API_KEY,
  authDomain: config.FB_AUTH_DOMAIN,
  projectId: config.FB_PROJECT_ID,
  storageBucket: config.FB_STORAGE_BUCKET,
  messagingSenderId: config.FB_MESSAGING_SENDER_ID,
  appId: config.FB_APP_ID,
  measurementId: config.FB_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

const performance = getPerformance(app);
performance.app.automaticDataCollectionEnabled = true;
performance.dataCollectionEnabled = true;

const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

function captureUTMs() {
  const params = new URLSearchParams(window.location.search);
  const utmSource = params.get('utm_source');
  const utmMedium = params.get('utm_medium');
  const utmCampaign = params.get('utm_campaign');
  const utmContent = params.get('utm_content');
  const utmTerm = params.get('utm_term');

  if (utmSource) {
    logEvent(analytics, 'utm_captured', {
      utm_source: utmSource,
      utm_medium: utmMedium,
      utm_campaign: utmCampaign,
      utm_content: utmContent,
      utm_term: utmTerm,
    });
  }
}

captureUTMs();

export { analytics, logEvent, setUserId, setUserProperties, performance, trace };
